module.exports = __webpack_public_path__ + "img/EDC3000&5000&8000.bce56158.png";